export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  // TWO FACTOR AUTHENTICATION
  'component.twoFactorAuth.modal.title': 'Setup Second Factor Authentication',
  'component.twoFactorAuth.modal.success': 'Successfully Activated 2FA!',
  'component.twoFactorAuth.modal.button.close': 'Close',
  'component.twoFactorAuth.modal.subTitle': 'You will now be logged out!',
  'component.twoFactorAuth.modal.submitBtn': 'Enable',
  'component.twoFactorAuth.modal.form.input.placeholder': 'Enter code from Your App.',
  'component.twoFactorAuth.modal.form.input.label': 'Code',
  'component.twoFactorAuth.modal.form.input.rules.required': 'Please enter the code',
  'component.twoFactorAuth.modal.form.input.rules.invalid':
    'Wrong authentication code. Please try again.',
  'component.twoFactorAuth.modal.qr.error': 'Failed to generate 2FA QR code',
  'component.twoFactorAuth.modal.enable.error': 'Failed to enable two-factor authentication',
  // API Key Generate
  'component.apiKey.modal.copy.message': 'API Key copied to clipboard!',
  'component.apiKey.modal.alert.warning':
    'Copy this token to access the ZPayment API. For security this will not be shown again.',
  'component.apiKey.modal.alert.info':
    'Click On the token or Copy Button to copy API key to clipboard.',
  'component.apiKey.modal.button.copy': 'Copy',
  'component.apiKey.modal.button.generate': 'Generate API Key',

  // API key HOC
  'component.apiKeyHoc.label': 'Generate API Key',
  'component.apiKeyHoc.success': 'API Key Removed!',
  'component.apiKeyHoc.error': 'Failed to Delete API Key, Please try again!',

  // API Key Table
  'component.apiKeyTable.column.no': 'No',
  'component.apiKeyTable.column.apiKey': 'API Key',
  'component.apiKeyTable.column.createdAt': 'Created At',
  'component.apiKeyTable.column.action': 'Action',
  'component.apiKeyTable.column.action.confirmation':
    'Are you sure you want to delete this record?',
  'component.apiKeyTable.column.action.confirmation.okText': 'Yes',
  'component.apiKeyTable.column.action.confirmation.cancelText': 'No',
  'component.apiKeyTable.column.action.delete': 'Delete',
  'component.apiKeyTable.title': 'Previous API Keys',
  'component.apiKey.modal.2fa.error': 'Please enter a valid 6-digit code',
  'component.apiKey.modal.2fa.invalid': 'Invalid 2FA code',

  'component.apiKey.modal.2fa.title': '2FA Verification',
  'component.apiKey.modal.2fa.description': 'Please enter your 2FA code to generate API key',

  // Webhook Api Key
  'component.webhookApiKey.label': 'Webhook Secret',
  'component.webhookApiKey.modal': 'Webhook Secret',
  'component.webhookApiKey.copy.error': 'API Key copied to clipboard!',
  'component.webhookApiKey.copy.success': `Sorry, Couldn't copy API Key!`,
  'component.webhookApiKey.button.generate': 'Generate',
  'component.webhookApiKey.button.regenerate': 'Regenerate',
  'component.webhookApiKey.button.copy': 'Copy',
  'component.webhookApiKey.modal.alert.warning':
    'Copy this token to access the ZPayment API. For security this will not be shown again.',
  'component.webhookApiKey.modal.alert.info':
    'Click On the token or Copy Button to copy API key to clipboard.',
  'component.webhookApiKey.input.placeholder': 'Empty',

  // Tron Energy Settings
  'component.tronEnergySettings.updateSuccess': 'Tron energy rental settings updated successfully',
  'component.tronEnergySettings.updateError': 'Failed to update Tron energy rental settings',
  'component.tronEnergySettings.label': 'Tron Energy Rental Settings',
  'component.tronEnergySettings.tooltip':
    'Enable or disable Tron energy rental for consolidate operations',
  'component.tronEnergySettings.consolidateFee.label': 'Enable Energy Rental for Consolidate Fee',
  'component.tronEnergySettings.consolidateFee.tooltip':
    'When enabled, the system will rent Tron energy for consolidate fee operations',
  'component.tronEnergySettings.consolidateFund.label': 'Enable Energy Rental for Consolidate Fund',
  'component.tronEnergySettings.consolidateFund.tooltip':
    'When enabled, the system will rent Tron energy for consolidate fund operations',

  // Create Sub User Form
  'component.createSubUserForm.form.label.firstName': 'First Name',
  'component.createSubUserForm.form.label.lastName': 'Last Name',
  'component.createSubUserForm.form.label.email': 'Email',
  'component.createSubUserForm.form.label.password': 'Password',
  'component.createSubUserForm.form.button.create': 'Create Sub User',
  'component.createSubUserForm.form.success': 'Sub user created successfully',
  'component.createSubUserForm.form.error': 'Failed to create sub user',
  'component.createSubUserForm.form.rules.email': 'Please input email',
  'component.createSubUserForm.form.rules.password': 'Please input password',
  'component.createSubUserForm.form.rules.password.uppercase':
    'Password must contain at least one uppercase letter',
  'component.createSubUserForm.form.rules.password.lowercase':
    'Password must contain at least one lowercase letter',
  'component.createSubUserForm.form.rules.password.number':
    'Password must contain at least one number',
  'component.createSubUserForm.form.rules.twoFactorCode': 'Please input two factor code',
  'component.createSubUserForm.form.label.twoFactorCode': '2FA Code',

  // Webhook Url Input
  'component.webhookUrlInput.label': 'Webhook Url',
  'component.withdrawWebhookUrlInput.label': 'Withdraw Webhook Url',
  'component.webhookUrlInput.error.invalid': 'Invalid Url',
  'component.webhookUrlInput.success': 'Webhook Url Updated Successfully!',
  'component.webhookUrlInput.error.updateFailed': 'Update Failed!',
  'component.webhookUrlInput.error.incorrectTwoFactorCode': 'Incorrect Two Factor Code!',
  'component.webhookUrlInput.modal.title': 'Enter Two Factor Code',
  'component.webhookUrlInput.modal.placeholder': 'Enter Two Factor Code',
  'component.webhookUrlInput.field.placeholder': 'Webhook Url',
  'component.withdrawWebhookUrlInput.field.placeholder': 'Withdraw Webhook Url',
  'component.withdrawRequestStatus.button.edit': 'Edit',

  // Email Input With Button
  'component.emailInputWithButton.label': 'Notification Email',
  'component.emailInputWithButton.success': 'Notification Email Updated',
  'component.minPayout.label': 'Min Collection (USDT)',

  // Fee rate
  'component.feeRateInput.label': 'Fee Rate %',
  'component.feeRateInput.modal.title': 'Enter Two Factor Code',
  'component.feeRateInput.field.placeholder': 'Enter Two Factor Code',

  // Withdraw Request Status
  'component.withdrawRequestStatus.label': 'Withdraw Request Approval',
  'component.withdrawRequestStatus.success': 'Withdraw Request setting updated successfully!',
  'component.withdrawRequestStatus.error': 'Failed to update Withdraw Request setting!',
  'component.withdrawRequestStatus.enabled.description':
    'Withdraw requests will be auto-approved if the amount is less than or equal to {amount} USDT.',
  'component.withdrawRequestStatus.modal.title': 'Set Auto-Approve Amount',
  'component.withdrawRequestStatus.modal.description':
    'Enter the maximum amount for auto-approval. Requests above this amount will require manual approval.',
  'component.withdrawRequestStatus.modal.input.placeholder': 'Enter amount',
  'component.withdrawRequestStatus.riskWarning':
    'Please be aware that auto-approval of withdraw requests can be risky. Please set the auto-approve amount threshold carefully',
  'component.withdrawRequestStatus.threshold.label': 'Auto Approve Threshold (USDT)',
  'component.withdrawRequestStatus.basicRiskAssessment.label': 'Basic Risk Assessment',
  'component.withdrawRequestStatus.customRiskAssessment.tooltip':
    'If the withdraw address is not seen before, it will require manual approval',
  'component.withdrawRequestStatus.customRiskAssessment.label': 'Reference Check Risk Assessment',
  'component.withdrawRequestStatus.riskAssessment.success':
    'Risk Assessment setting updated successfully',
  'component.withdrawRequestStatus.riskAssessment.error': 'Failed to update Risk Assessment setting',
  'component.withdrawRequestStatus.prefixLength.value': 'Prefix Length: {length}',

  // Withdraw Request Page
  'withdrawRequests.page.fetch.error': 'Failed to fetch Withdraw Requests',
  'withdrawRequests.page.approve.success': 'Withdraw Request approved successfully!',
  'withdrawRequests.page.approve.error': 'Failed to approve Withdraw Request',
  'withdrawRequests.page.reject.success': 'Withdraw Request rejected successfully!',
  'withdrawRequests.page.reject.error': 'Failed to reject Withdraw Request',
  'withdrawRequests.page.table.column.number': 'No.',
  'withdrawRequests.page.table.column.fromAddress': 'From Address',
  'withdrawRequests.page.table.column.toAddress': 'To Address',
  'withdrawRequests.page.table.column.amount': 'Amount',
  'withdrawRequests.page.table.column.reference': 'Reference',
  'withdrawRequests.page.table.column.timestamps': 'Timestamps',
  'withdrawRequests.page.table.column.token': 'Token',
  'withdrawRequests.page.table.column.network': 'Network',
  'withdrawRequests.page.table.column.status': 'Status',
  'withdrawRequests.page.table.column.action': 'Action',
  'withdrawRequests.page.table.action.approve': 'Approve',
  'withdrawRequests.page.table.action.reject': 'Reject',
  'withdrawRequests.page.table.column.remark': 'Remark',
  'withdrawRequests.page.table.column.automated': 'Automated',
  'withdrawRequests.page.table.automationRemark': 'Auto-approved: Amount below threshold {number}',
  'withdrawRequests.modal.approve.title': 'Approve Withdraw Request',
  'withdrawRequests.modal.reject.title': 'Reject Withdraw Request',
  'withdrawRequests.modal.approve.content':
    'Are you sure you want to approve this withdraw request?',
  'withdrawRequests.modal.reject.content': 'Are you sure you want to reject this withdraw request?',
  'component.withdrawRequestStatus.modal.input.rules.required': 'Please enter an amount',
  'component.withdrawRequestStatus.modal.input.validation': 'Amount must be between 0 and 500,000',

  // Reference Check Settings
  'component.withdrawRequestStatus.referenceCheck.modal.title': 'Reference Check Configuration',
  'component.withdrawRequestStatus.referenceCheck.preview.description':
    'This feature checks if the withdrawal address has been used before by comparing reference prefixes. If the address has no withdrawal history, it will require manual approval for enhanced security.',
  'component.withdrawRequestStatus.referenceCheck.preview.title': 'Preview:',
  'component.withdrawRequestStatus.referenceCheckRange.checkPrefixLength.required':
    'Check prefix length is required',
  'component.withdrawRequestStatus.referenceCheckRange.checkPrefixLength.placeholder':
    'Check Prefix Length',
  'component.withdrawRequestStatus.referenceCheckRange.checkPrefixLength.label':
    'Check Prefix Length',

  // Transactions Page
  'transactions.table.column.tx': 'Tx',
  'transactions.table.column.id': 'ID',
  'transactions.table.column.from': 'From',
  'transactions.table.column.to': 'To',
  'transactions.table.column.transferDirection': 'IN | OUT',
  'transactions.table.column.network': 'Network',
  'transactions.table.column.amount': 'Amount',
  'transactions.table.column.date': 'Date',
  'transactions.table.column.fee': 'Fee Amount',
  'transactions.table.column.fee.short': 'Fee',
  'transactions.table.column.time': 'TimeStamp',
  'transactions.table.column.time.short': 'Time',
  'transactions.table.column.afterFee': 'Amount After Fee',
  'transactions.table.column.afterFee.short': 'After Fee',
  'transactions.table.button.export': 'Export',
  'transactions.table.select.placeholder': 'Transfer Direction',
  'transactions.table.content.from': 'From',
  'transactions.table.content.to': 'To',
  'transactions.table.error.export': 'Failed to export transactions',
  'transactions.table.error.fetch': 'Failed to fetch transactions',

  // CSV Export
  'csv.export.modal.title': 'Exporting Data',
  'csv.export.modal.cancel': 'Cancel Export',
  'csv.export.modal.progress': 'Processing page {current} of {total}...',
  'csv.export.modal.records': '{processed} of {total} records processed',
  'csv.export.modal.large.warning': 'Large export in progress',
  'csv.export.modal.large.description':
    'This export contains a large number of records. Please be patient and avoid closing this window.',
  'csv.export.modal.note': 'Please keep this window open until the export completes.',
  'csv.export.cancel.confirm.title': 'Cancel Export',
  'csv.export.cancel.confirm.content':
    'Are you sure you want to cancel the export? Progress will be lost.',
  'csv.export.cancel.confirm.ok': 'Yes, Cancel',
  'csv.export.cancel.confirm.cancel': 'Continue Export',
  'csv.export.success': 'Data exported successfully!',
  'csv.export.error': 'Failed to export data. Please try again.',
  'csv.export.warning.title': 'Large Export Warning',
  'csv.export.warning.content':
    'You are about to export {count} records. This may take several minutes. Do you want to continue?',
  'csv.export.warning.continue': 'Continue Export',
  'csv.export.warning.cancel': 'Cancel',
  'csv.export.error.no_data': 'No data received from server',
  'csv.export.error.too_many_records':
    'Too many records ({count}). Maximum allowed is {max}. Please narrow your search criteria.',
  'csv.export.error.cancelled': 'Export cancelled by user',
  'transactions.export.limit.note':
    'Export is limited to a maximum of 3 months. Please narrow your date range.',
  'transactions.export.limit.short': 'Max 3 months range for export',
  'transactions.export.no_data': 'No data to export for current filters.',
  'transactions.export.max_records': 'No filters applied: up to 10,000 records will be exported.',
  'consolidate_fee_logs.export.no_data': 'No data to export for current filters.',
  'consolidate_logs.export.no_data': 'No data to export for current filters.',

  // API Key
  'component.apiKeyTable.column.name': 'Name',
  'component.apiKeyTable.column.active': 'Active',
  'component.apiKeyTable.delete.confirm': 'Are you sure to delete this API key?',
  'component.apiKeyTable.delete.confirm.yes': 'Yes',
  'component.apiKeyTable.delete.confirm.no': 'No',
  'component.apiKeyTable.delete.button': 'Delete',
  'component.apiKeyTable.delete.success': 'API Key deleted successfully!',

  'component.v2ApiKeyGenerate.success': 'API Key created successfully',
  'component.v2ApiKeyGenerate.createError': 'Failed to create API key',
  'component.v2ApiKeyGenerate.button.open': 'Generate Key',
  'component.v2ApiKeyGenerate.modal.title': 'Generated API Key',
  'component.v2ApiKeyGenerate.modal.button.create': 'Create API Key',
  'component.v2ApiKeyGenerate.modal.alert.warning':
    "Don't Share your private key with anyone, not even us!",
  'component.v2ApiKeyGenerate.publicKey': 'Public Key',
  'component.v2ApiKeyGenerate.apiKey': `Your API Key, Store it securely, it won't be shown again!`,

  // Merchant Consolidation
  'component.merchantConsolidation.addWalletFirst':
    'Please add a fee wallet first to enable consolidation.',
  'component.merchantConsolidation.toggle.success': 'Consolidation status updated successfully',
  'component.merchantConsolidation.toggle.error': 'Failed to update consolidation status',
  'component.merchantConsolidation.feeWallet.label': 'Fee Wallet Consolidation',
  'component.merchantConsolidation.noWalletsMessage':
    'No fee wallets configured. Add a wallet to enable consolidation.',
  'component.merchantConsolidation.noFeeWalletsMessage':
    'No fee wallets configured yet. Add a wallet to enable consolidation.',
  'component.merchantConsolidation.enabledDescription':
    'Automatically consolidate transaction fees to configured wallets.',
  'component.merchantConsolidation.disabledDescription':
    'Fee consolidation is currently disabled. Enable to start consolidating.',
  'component.merchantConsolidation.manageWalletsButton': 'Manage Wallets',
  'component.merchantConsolidation.manageFeeWalletsButton': 'Manage Fee Wallets',
  'component.merchantConsolidation.2fa.modal.title': 'Enter 2FA Code to Confirm Action',
  'common.confirm': 'Confirm',
  'component.merchantConsolidation.2fa.label': '2FA Authentication Code',
  'component.merchantConsolidation.2fa.required': 'Please enter your 2FA code',
  'component.merchantConsolidation.2fa.length': '2FA code must be 6 digits',
  'component.merchantConsolidation.2fa.placeholder': 'Enter 6-digit 2FA code',
  'component.merchantConsolidation.label': 'Merchant Consolidation Settings',
  'component.addMerchantWallet.addWallet.success': 'Fee wallet added successfully',
  'component.addMerchantWallet.addWallet.error': 'Failed to add fee wallet',
  'component.addMerchantWallet.modal.manageWalletsTitle': 'Manage Fee Wallets',
  'component.addMerchantWallet.modal.addWalletButton': 'Add Wallet',
  'settings.consolidation.updateWallets.success': 'Wallets updated successfully',
  'settings.consolidation.configureWalletsTitle': 'Configure Consolidation Wallets',
  'settings.consolidation.saveButton': 'Save Changes',
  'settings.consolidation.notSet': 'Not Set',
  'settings.consolidation.updateWallets.error': 'Failed to update wallets',
  'settings.consolidation.updateWallets.modal.title': 'Confirm Wallet Update',
  'settings.consolidation.updateWallets.modal.prompt':
    'Please enter your 2FA code to update the consolidation wallets.',
  'settings.consolidation.updateWallets.modal.cancel': 'Cancel',
  'settings.consolidation.updateWallets.modal.confirm': 'Confirm Update',
  'settings.consolidation.clearAddress': 'Clear',
  'settings.consolidation.editAddress': 'Edit',
  'settings.consolidation.addressHelpText':
    'Leave empty if you do not wish to set a wallet for this network.',
  'component.addMerchantWallet.warning.title': 'Important Security Notice',
  'component.addMerchantWallet.warning.description':
    'Please verify all wallet addresses carefully. Incorrect addresses will result in permanent loss of funds. Ensure you have full control over the destination wallets.',
  'component.addMerchantWallet.network.label': 'Network',
  'component.addMerchantWallet.network.placeholder': 'Select Network',
  'component.addMerchantWallet.address.label': 'Wallet Address',
  'component.addMerchantWallet.address.placeholder': 'Enter wallet address',
  'component.addMerchantWallet.2fa.label.addWallet': '2FA Authentication Code (for adding wallet)',
  'component.addMerchantWallet.2fa.required.addWallet':
    'Please enter your 2FA code to add the wallet',
  'component.addMerchantWallet.2fa.length': '2FA code must be 6 digits',
  'component.addMerchantWallet.2fa.placeholder.addWallet': 'Enter 6-digit 2FA code',
  'component.merchantWallets.noWalletsMessage': 'No existing wallets',
  'component.merchantWallets.noWalletsDescription':
    "You haven't configured any fee wallets yet. Add your first wallet using the form below.",
  'component.merchantWallets.currentFeeWalletsTitle': 'Current Fee Wallets',
  'component.addMerchantWallet.modal.configureWalletsTitle': 'Configure Consolidation Wallets',
  'component.addMerchantWallet.modal.saveButton': 'Save',
  'component.addMerchantWallet.2fa.label.updateWallets': '2FA Authentication Code',
  'component.addMerchantWallet.clickEditToChange': 'Click edit to change',
  // Fund wallet consolidation translations
  'component.merchantConsolidation.addFundWalletFirst':
    'Please add a fund wallet first to enable consolidation.',
  'component.merchantConsolidation.fundWallet.label': 'Fund Wallet Consolidation',
  'component.merchantConsolidation.noFundWalletsMessage':
    'No fund wallets configured. Add a wallet to enable consolidation.',
  'component.merchantConsolidation.fundEnabledDescription':
    'Automatically consolidate funds to configured wallets.',
  'component.merchantConsolidation.fundDisabledDescription':
    'Fund consolidation is currently disabled. Enable to start consolidating.',
  'component.merchantConsolidation.feeEnabledDescription':
    'Automatically consolidate transaction fees to configured wallets.',
  'component.merchantConsolidation.manageFundWalletsButton': 'Manage Fund Wallets',
  'component.merchantConsolidation.feeDisabledDescription':
    'Fee consolidation is currently disabled. Enable to start consolidating.',

  // Fund wallet modal and form translations
  'component.addMerchantFundWallet.updateWallets.success':
    'Fund wallet configuration updated successfully',
  'component.addMerchantFundWallet.updateWallets.error':
    'Failed to update fund wallet configuration',
  'component.addMerchantFundWallet.modal.configureWalletsTitle': 'Configure Fund Wallets',
  'component.addMerchantFeeWallet.modal.configureWalletsTitle': 'Configure Fee Wallets',
  'component.addMerchantFundWallet.modal.saveButton': 'Save',
  'component.addMerchantFeeWallet.address.placeholder': 'Enter wallet address',
  'component.addMerchantFeeWallet.notSet': 'Not set. Enter address to configure.',
  'component.addMerchantFundWallet.warning.title': 'Important Security Notice',
  'component.addMerchantFundWallet.warning.description':
    'Please verify all wallet addresses carefully. Incorrect addresses will result in permanent loss of funds.',
  'component.addMerchantFundWallet.address.placeholder': 'Enter wallet address',
  'component.addMerchantFundWallet.clickEditToChange': 'Click edit to change',
  'component.addMerchantFundWallet.notSet': 'Not set. Enter address to configure.',
};
